// Native & external imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule  } from '@angular/router';
// Modules
import { SharedUiComponentsModule } from 'src/modules/shared-ui-components/shared-ui-components.module';
// Components
import { NotFoundComponent } from './not-found.component';
import { CmpSharedModule } from 'icamppro-shared-components';
// Exports
export { NotFoundComponent } from './not-found.component';

@NgModule({
  declarations: [
    NotFoundComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    SharedUiComponentsModule,
    CmpSharedModule
  ],
  exports: [
    NotFoundComponent
  ]
})
export class NotFoundModule { }
